var savedAddressMixin = {
    data: function () {
        return {
            addressId: 0,
            showSaveAddressCheckBox: true
        }
    },
    methods: { 
        /**
         * Selects the saved address for populating into the address and details form fields 
         * @param {any} event 
         */
        selectSavedAddress: function (event) {
            const vm = this;
            var index = event.target.selectedIndex;

            if (index > 0) {
                index--;
                vm.address = vm.addresses[index];
                
            } else {
                vm.address = {};
            }
            vm.showEnterAddressManually = false;
            vm.enterAddressManually();
            vm.showSaveAddressCheckBox = false;
        },
        /**
         * Puts the company name value in the dropdown if it exists
         * @param {string} value Company name
         */
        hasCompanyName: function (value) {
            return (value !== '' && value !== undefined) ? value + ' - ' : '';;
        },
        getAddresses: function () {
            const vm = this;
            vm.getAddressesApi()
                .then(function (response) {
                    if (!response)
                        return;

                    const content = response.data.content;

                    vm.addresses = content;
                    vm.loaded = true;
                });
        }
    }
}